import styles from './index.module.scss';
import ProductContent from './ProductContent';

const TempCommon = () => {
    return (
        <div className={styles.landing}>
            <ProductContent />
        </div>
    );
};
export default function Teaser() {
    return <TempCommon></TempCommon>;
}
